import React from 'react';
import { motion } from 'framer-motion';
const contents = [{
  emoji: '📘',
  title: '6 Tomos Digitales Completos',
  text: 'Un sistema paso a paso para que nunca más vuelvas a preguntarte qué tejer.'
}, {
  emoji: '🌳',
  title: 'El Árbol Inteligente de Decisiones',
  text: 'Responde cinco preguntas y descubre exactamente cuál es el proyecto perfecto para hoy.'
}, {
  emoji: '🧶',
  title: 'Banco de Proyectos Organizado',
  text: 'Por tiempo disponible, cantidad de lana, estado de ánimo y objetivo.'
}, {
  emoji: '📅',
  title: 'Planificador de 30 Días',
  text: 'Recupera el hábito de terminar lo que empiezas y deja atrás los proyectos olvidados.'
}, {
  emoji: '🧰',
  title: 'Caja de Herramientas de la Tejedora',
  text: 'Checklists, plantillas y recursos para decidir en segundos cada vez que quieras tejer.'
}, {
  emoji: '🎯',
  title: 'Para Crochet, Dos Agujas y Tejido Tradicional',
  text: 'No importa cómo te guste tejer. El sistema funciona para cualquier técnica.'
}];
const receive = [{
  emoji: '📘',
  strong: 'Los 6 Tomos Digitales:',
  text: 'un sistema completo para decidir qué tejer en cualquier momento.'
}, {
  emoji: '🌳',
  strong: 'El Árbol Inteligente de Decisiones:',
  text: 'el método que elimina la indecisión en menos de 2 minutos.'
}, {
  emoji: '📋',
  strong: 'Plantillas y Herramientas Prácticas:',
  text: 'checklists, calendarios y fichas listas para imprimir o usar desde tu celular.'
}, {
  emoji: '🧶',
  strong: 'Banco de Ideas Organizado:',
  text: 'proyectos clasificados para aprovechar cualquier ovillo, cualquier momento y cualquier objetivo.'
}];
export function WhatsInside() {
  return <section className="w-full bg-cream-2 px-4 py-14" data-id="element-238" data-mp="2y36w9zhc7y4n">
      <div className="mx-auto max-w-3xl text-center" data-id="element-239" data-mp="2ae4d2n721x81">
        <h2 className="font-display text-2xl font-black leading-tight text-plum-deep sm:text-4xl" data-id="element-240" data-mp="26e3o48mby3mq">
          📦 ¿Qué contiene el Sistema{' '}
          <span className="text-mauve" data-id="element-241" data-mp="9cg1ncowwf8a">¿Qué Tejo Hoy?™</span>?
        </h2>
      </div>

      <div className="mx-auto mt-8 grid max-w-3xl gap-4 sm:grid-cols-2" data-id="element-242" data-mp="eb93u8yr0jt5">
        {contents.map((c, i) => <motion.div key={c.title} initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i % 2 * 0.08
      }} className="rounded-2xl bg-white p-5 shadow-sm ring-1 ring-mauve-soft/40" data-id="element-243" data-mp="j4bzqnr005ci" data-mpi={i}>
            <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-xl bg-mauve-soft/40 text-2xl" data-id="element-244" data-mp="3rknkale8gzc1">
              {c.emoji}
            </div>
            <h3 className="font-display text-lg font-bold text-plum" data-id="element-245" data-mp="5cdy0xzm9bqd">
              {c.title}
            </h3>
            <p className="mt-1.5 text-sm leading-relaxed text-plum/75" data-id="element-246" data-mp="1br6gb9kp2kkp">
              {c.text}
            </p>
          </motion.div>)}
      </div>

      {/* What you receive immediately */}
      <div className="mx-auto mt-12 max-w-2xl" data-id="element-247" data-mp="318agh4koqjrb">
        <h3 className="text-center font-display text-xl font-black text-plum-deep sm:text-3xl" data-id="element-248" data-mp="2w9z6mtue4993">
          📲 ¿Qué recibirás inmediatamente?
        </h3>
        <ul className="mt-6 space-y-3" data-id="element-249" data-mp="2rhforkoo6ryh">
          {receive.map(r => <li key={r.strong} className="flex items-start gap-3 rounded-xl bg-white p-4 shadow-sm" data-id="element-250" data-mp="2miw5xt5dhwac">
              <span className="text-xl leading-none" data-id="element-251" data-mp="2hiqb643t3to1">{r.emoji}</span>
              <p className="text-sm text-plum/80" data-id="element-252" data-mp="2dig04d15qd2b">
                <strong className="text-plum" data-id="element-253" data-mp="28jwg4i64jbcl">{r.strong}</strong> {r.text}
              </p>
            </li>)}
        </ul>
        <p className="mt-6 text-center font-display text-base font-semibold italic text-mauve sm:text-lg" data-id="element-254" data-mp="23m3c9vsamtfh">
          Cualquier ovillo que tengas… el Sistema ¿Qué Tejo Hoy?™ ya tiene la
          respuesta.
        </p>
      </div>
    </section>;
}